import React from 'react';

import CoreDeliveryProvider from '../../../Providers/DeliveryProvider';

const DeliveryProvider = ({ children, ...rest }) => (
  <CoreDeliveryProvider {...rest} demo={false} channelDriverName="Converse">
    {children}
  </CoreDeliveryProvider>
);

export default DeliveryProvider;
